import { translate } from "app/filters/i18nFilter";
import { FieldsDropdown } from "app/pages/sales-intelligence/modules/enrichment/components/FieldsDropdown/FieldsDropdown";

import {
    StyledColumnPickerSection,
    StyledFieldsWrapper,
    StyledPixelPlaceholderLoader,
} from "../../containers/EnrichmentCsvContainer/style";

import type { ColumnPickersProps } from "./type";

export const ColumnPickers = ({
    head,
    config,
    isLoading,
    selectedConfigFields,
    type = "company",
    renderFieldBadge,
    onApply,
}: ColumnPickersProps) => {
    return (
        <StyledColumnPickerSection type={type}>
            {head}

            {isLoading ? (
                <>
                    <StyledPixelPlaceholderLoader
                        height="30px"
                        width="600px"
                    />
                    <StyledPixelPlaceholderLoader
                        height="30px"
                        width="600px"
                    />
                    <StyledPixelPlaceholderLoader
                        height="30px"
                        width="600px"
                    />
                    <StyledPixelPlaceholderLoader
                        height="30px"
                        width="600px"
                    />
                </>
            ) : (
                config.map(({ fields, name, labelKey }, index) => {
                    return (
                        <StyledFieldsWrapper key={index}>
                            <FieldsDropdown
                                selectedFields={selectedConfigFields[name] ?? []}
                                configLabel={translate(labelKey)}
                                fields={fields}
                                configName={name}
                                type={type}
                                renderFieldBadge={name !== "contacts" ? renderFieldBadge : undefined}
                                onApply={onApply}
                            />
                        </StyledFieldsWrapper>
                    );
                })
            )}
        </StyledColumnPickerSection>
    );
};
